<main class="container-fluid s-grid-section mb-5 p-3">
    <div class="w-fit mb-4">
        <app-back-button routerLink="/referrals" component="Referrals"></app-back-button>
    </div>
    <div class="mt-3 mb-4 d-flex justify-content-between align-items-center">
        <div class="font-weight-bold">
            <h1>{{ referral!.referralCode }} Referral Detail</h1>
        </div>
    </div>
    <mat-card class="mt-3 pb-3">
        <div class="s-row s-grid-row-section">
            <div class="s-col-12">
                <div class="referral-component">
                    <div class="form-section mt-2">
                        <h4 class="span-2 s-mt-15">Referral Code</h4>
                        <mat-form-field class="span-2" appearance="fill" hideRequiredMarker>
                            <mat-label>Code<span class="required-input">*</span></mat-label>
                            <input [(ngModel)]="referral!.referralCode" matInput placeholder="Referral code..." required="true">
                        </mat-form-field>
                        <h4 class="span-2">Referral Type</h4>
                        <mat-form-field class="span-2 mb-2" appearance="fill">
                            <mat-label>Select Referral Type</mat-label>
                            <mat-select [(ngModel)]="referral!.type" name="referralType">
                                @for (type of referral!.getTypes(); track $index;) {
                                    <mat-option [value]="type">
                                        {{type}}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div *ngFor="let p of referral!.payees; let i = index;">
                        <div class="form-section">
                            <h4 class="span-2 s-mt-15">Payee {{i + 1}}</h4>
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Legacy Org Id<span class="required-input">*</span></mat-label>
                                <input [(ngModel)]="p.legacyOrganizationId" name="legacyOrganizationId" matInput
                                    placeholder="Legacy Org Id..." required="true">
                            </mat-form-field>
                            <mat-form-field appearance="fill" class="">
                                <mat-label>Organization Id</mat-label>
                                <input [(ngModel)]="p.organizationId" matInput placeholder="Org Id...">
                            </mat-form-field>
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Commission (%)<span class="required-input">*</span></mat-label>
                                <input [(ngModel)]="p.commission!.amount" type="number" matInput
                                    placeholder="Commission Percentage..." required="true" min="0" max="100" step="0.01" onkeypress="return event.charCode != 45" oninput="if(this.value > 100) this.value = 100;">
                            </mat-form-field>
                        </div>
                        <div class="form-section s-mt-15 mb-3">
                            <button mat-raised-button class="action-button" (click)="referral!.addPayee(null)">
                                Add Payee
                            </button>
                            <button *ngIf="referral?.payees!.length > 1" mat-raised-button class="warn-button" (click)="referral!.removeLastPayee()">
                                Remove Payee
                            </button>
                        </div>
                    </div>
                    <div class="form-section s-mt-15 my-2">
                        <h4 class="span-2 s-mt-30 mt-3">Status</h4>
                        <mat-form-field class="span-2 " appearance="fill">
                            <mat-label>Status</mat-label>
                            <mat-select [(ngModel)]="referral!.status" name="status">
                                <mat-option *ngFor="let type of referral!.getStatusTypes()" [value]="type">
                                    {{type}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div *ngIf="referral?.notes && referral!.notes.length >= 1 
                        && referral && referral.notes && referral.notes[0].comment !== ''" class="span-2 mb-3">
                        <h4 class="span-2 s-mt-35">Notes</h4>
                        <div *ngFor="let note of referral!.notes; let i = index;" class="referral-note-section">
                            <div class="referral-note-subsection mb-2">
                                <label *ngIf="note.author">Author: {{note.author}}</label>
                                <label *ngIf="note.subject">Subject: {{note.subject}}</label>
                                <label *ngIf="note.comment">Comment: {{note.comment}}</label>
                                <label *ngIf="note.createdDate">Posted: {{note.createdDate | date}}</label>
                                <label *ngIf="note.lastModifiedDate">Last Modified: {{note.lastModifiedDate | date}}</label>
                            </div>
                            <div class="form-section s-mt-15 mt-1">
                                <button mat-raised-button (click)="openEditReferralNoteDialog(note, i)">
                                    Edit Note
                                </button>
                                <button mat-raised-button class="warn-button" (click)="onDeleteReferralNoteClick(i)">
                                    Delete Note
                                </button>
                            </div>
                            <mat-divider class="referral-divider"></mat-divider>
                        </div>
                    </div>
                    <div class="form-section span-2 mt-3">
                        <h4 class="span-2 s-mt-35 ">Add Note</h4>
                        <mat-form-field class="span-2 " appearance="fill">
                            <mat-label>Subject</mat-label>
                            <input [(ngModel)]="subject" type="text" matInput placeholder="Subject...">
                        </mat-form-field>
                        <mat-form-field class="span-2 " appearance="fill">
                            <mat-label>Note</mat-label>
                            <textarea [(ngModel)]="comment" style="min-height: 100px ;" matInput></textarea>
                        </mat-form-field>
                    </div>
                    <div class="col d-flex flex-col mt-2 mb-2 justify-content-end">
                        <button mat-raised-button class="cancel-button" routerLink="/referrals">
                            <mat-icon>cancel</mat-icon>
                            Cancel
                        </button>
                        <button [disabled]="!canSubmit()" class="action-button" mat-raised-button (click)="updateReferral()">
                            <mat-icon>check</mat-icon>
                            Update Referral
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </mat-card>
</main>